export type BaseDashboard = {
  id: string;
  name: string;
};

export function dashboardGetKey(item: BaseDashboard) {
  return item.id;
}

export function dashboardGetValue(item: BaseDashboard) {
  return item.name;
}
